import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import ClassicQuizUserParticipationModel from "./ClassicQuizUserParticipationModel";

export default class ClassicQuizUserParticipationsModel {
  public meta: MetaModel = new MetaModel();
  public data: ClassicQuizUserParticipationModel[] = [];
}
